export default __webpack_public_path__ + "static/media/köide_005.9f81050d.png";